var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSourceApps(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.0591 101.212L139.48 88.8131L168.129 106.724V161.234L219.576 148.984V207.168L114.845 234.729L86.0591 211.456V101.212Z",
    fill: "#F8EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0591 101.212L139.48 88.8131L168.129 106.724M86.0591 101.212L114.845 117.749M86.0591 101.212V211.456L114.845 234.729M114.845 117.749L168.129 106.724M114.845 117.749V234.729M168.129 106.724V161.234L219.576 148.984V207.168L114.845 234.729",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.447 54.6646L139.548 88.7782L86.0594 101.502V211.455L57.8861 188.485V134.285L34 116.523V65.0764L85.447 54.6646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 65.0764L85.447 54.6646L139.548 88.7782L86.0594 101.502M34 65.0764L86.0594 101.502M34 65.0764V116.523L57.8861 134.285V188.485L86.0594 211.455V101.502",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 217.58L57.2736 241.466L57.8861 134.285L34 116.524V217.58Z",
    fill: "#BBDDE7",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2744 241.466L57.8869 188.795L114.846 234.729L219.577 207.168V260.453L114.846 289.239L57.2744 241.466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.846 289.239L57.2744 241.466L57.8869 188.795L114.846 234.729M114.846 289.239L219.577 260.453V207.168L114.846 234.729M114.846 289.239V234.729",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.124 137.96L219.577 148.984V260.452L266.736 246.978L266.124 137.96Z",
    fill: "#F8FBFC",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.123 137.959L168.129 161.233V106.724L110.557 70.5882L160.167 59.5638L187.115 77.9378L234.887 67.5259L266.123 85.8998V137.959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.129 106.724V161.233L266.123 137.959V85.8998M168.129 106.724L266.123 85.8998M168.129 106.724L110.557 70.5882L160.167 59.5638L187.115 77.9378L234.887 67.5259L266.123 85.8998",
    stroke: "#222222",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 13.0672,
    y2: -0.3,
    transform: "matrix(0.234968 -0.915426 -1.0222 -0.235393 179.24 23.6842)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 7.80302,
    y2: -0.3,
    transform: "matrix(-0.837427 0.495293 -0.500332 -0.881406 192.082 25.9026)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.3,
    y1: -0.3,
    x2: 7.02842,
    y2: -0.3,
    transform: "matrix(0.445132 0.903155 -0.892771 0.41233 168.904 18.021)",
    stroke: "#222222",
    strokeWidth: 0.6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.93 35.6781L234.889 67.5262L187.117 77.9381L160.169 59.5642L110.851 70.6444L85.5264 54.6417L177.93 35.6781Z",
    fill: "#EBF5F8",
    stroke: "#222222",
    strokeWidth: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSourceApps);
export default __webpack_public_path__ + "static/media/data-source-apps.f3773b2f39167abd91441568c2ac634c.svg";
export { ForwardRef as ReactComponent };